<template>
    <div class="fixed-router">
        <router-link to="/report" tag="div" class="fixed-router-item">媒体报导</router-link>
        <router-link to="/terms" tag="div" class="fixed-router-item">服务条款</router-link>
        <router-link to="/help" tag="div" class="fixed-router-item">帮助中心</router-link>
        <router-link to="/video" tag="div" class="fixed-router-item">视频教程</router-link>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped lang="scss">

.fixed-router{
  position: fixed;
  bottom: 30px;
  right: 70px;
  z-index: 9999;
  .active{
      color:#ce1212;
  }
}
.fixed-router-item{
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  background:#fff;
  margin-bottom: 10px;
  cursor: pointer;
}
.fixed-router-item:hover{
  color:#ce1212;
}
</style>


// WEBPACK FOOTER //
// src/components/fixedRouter.vue